// extracted by mini-css-extract-plugin
export default {"tabListItem":"Tab_tabListItem__V0LGl","tabListActive":"Tab_tabListActive__BzgY6"};